var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-bar',[_c('user-menu'),_c('hr',{staticClass:"uk-margin"}),_c('template',{slot:"links"},[(_vm.role === 'retoucher')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_order,
            icon: 'wallpaper',
            path: '/new_mvp/order-new-idle-time',
          }}}):_vm._e(),(_vm.role === 'junior-retoucher')?_c('sidebar-item',{attrs:{"link":{
          //name: location_keys.menu_order_verification,
           name: _vm.location_keys.menu_order,
          icon: 'wallpaper',
          path: '/new_mvp/juniorRetoucherOrder',
        }}}):_vm._e(),(_vm.role === 'retoucher' || _vm.role === 'junior-retoucher')?_c('sidebar-item',{attrs:{"notification":_vm.notiferRetoucherRating,"link":{
          name: _vm.location_keys.menu_progress_report,
          icon: 'local_activity',
          path: '/new_mvp/retoucherProgressReport',
        }}}):_vm._e(),(_vm.role === 'pro-retoucher')?_c('sidebar-item',{attrs:{"link":{
          name: _vm.location_keys.menu_order_verification,
          icon: 'wallpaper',
          path: '/new_mvp/orderCheck',
        }}}):_vm._e(),(_vm.role === 'pro-retoucher' && ('education_pro_retoucher' in _vm.userProfile && _vm.userProfile.education_pro_retoucher))?_c('sidebar-item',{attrs:{"link":{
          // name: location_keys.menu_order_verification,
          name: 'Проверка заказов EDU',
          icon: 'school',
          path: '/new_mvp/orderCheckEducation',
        }}}):_vm._e(),(_vm.role === 'pro-retoucher' && ('education_pro_retoucher' in _vm.userProfile && _vm.userProfile.education_pro_retoucher))?_c('sidebar-item',{attrs:{"link":{
          // name: location_keys.menu_order_verification,
          name: 'История заказов EDU',
          icon: 'history_edu',
          path: '/new_mvp/orderEducationHistory',
        }}}):_vm._e(),(_vm.role === 'pro-retoucher')?_c('sidebar-item',{attrs:{"notification":_vm.notiferProRetoucherRating,"link":{
          name: _vm.location_keys.menu_progress_report,
          icon: 'local_activity',
          path: '/new_mvp/proRetoucherProgressReport',
        }}}):_vm._e(),(_vm.role === 'senior-retoucher')?_c('sidebar-item',{attrs:{"link":{
          name: _vm.location_keys.menu_order_verification,
          icon: 'wallpaper',
          path: '/new_mvp/seniorRetoucherOrderCheck',
        }}}):_vm._e(),(_vm.role === 'test-retoucher')?[_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_order_for_retoucher,
            icon: 'wallpaper',
            path: '/new_mvp/order_for_test_retoucher',
          }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.location_keys.menu_order_verification_for_pro_retoucher,
              icon: 'wallpaper',
              path: '/new_mvp/orderCheck_for_test_retoucher',
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.location_keys.menu_order_verification_for_senior_retoucher,
              icon: 'wallpaper',
              path: '/new_mvp/seniorRetoucherOrderCheck_for_test_retoucher',
            }}})]:_vm._e(),(_vm.role === 'admin' || _vm.role === 'mini-admin' || _vm.role === 'senior-retoucher')?_c('sidebar-item',{class:_vm.role === 'admin' || _vm.role === 'mini-admin' || _vm.role === 'senior-retoucher' ? 'tm-sidebar-scheduletable3' : '',attrs:{"link":{
            name: _vm.location_keys.menu_timetable,
            icon: 'calendar_month',
            path: '/components/scheduletable3',
          }}}):_vm._e(),(_vm.role === 'retoucher' || _vm.role === 'junior-retoucher' || _vm.role === 'test-retoucher' || _vm.role === 'admin' || _vm.role === 'mini-admin' || _vm.role === 'senior-retoucher')?_c('sidebar-item',{class:_vm.role === 'admin' || _vm.role === 'mini-admin' || _vm.role === 'senior-retoucher' ? 'tm-sidebar-scheduletable4' : '',attrs:{"link":{
            name: _vm.location_keys.menu_timetable,
            icon: 'calendar_month',
            path: '/components/scheduletable4',
          }}}):_vm._e(),(_vm.role === 'admin' || _vm.role === 'mini-admin' || _vm.role === 'senior-retoucher')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_timetable,
            icon: 'work_history',
            path: '/components/scheduletable-pro',
          }}}):_vm._e(),(_vm.role === 'pro-retoucher')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_timetable,
            icon: 'work_history',
            path: '/components/scheduletable-pro',
          }}}):_vm._e(),(_vm.role === 'admin' || _vm.role === 'mini-admin')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_users,
            icon: 'people',
            path: '/components/users',
          }}}):_vm._e(),(_vm.role === 'admin')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_localization,
            icon: 'language',
            path: '/components/translate',
          }}}):_vm._e(),(_vm.role === 'admin')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_application_settings,
            icon: 'settings',
            path: '/components/startbonus',
          }}}):_vm._e(),((_vm.role === 'admin' || _vm.role === 'senior-retoucher') && _vm.userProfile.email !== 'senior-retoucher03@retoucher.app')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_salary_page,
            icon: 'request_quote',
            path: '/components/salary2',
          }}}):_vm._e(),(_vm.role === 'admin')?_c('sidebar-item',{attrs:{"link":{
            // name: location_keys.menu_elements_page,
            name: _vm.location_keys.menu_functions_list,
            icon: 'storage',
            path: '/new_mvp/functions_elements',
          }}}):_vm._e(),(_vm.role !== 'test-admin')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_functions_description,
            icon: 'format_list_bulleted',
            path: '/new_mvp/functions_description',
          }}}):_vm._e(),(_vm.role === 'retoucher' || _vm.role === 'junior-retoucher')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_wages,
            icon: 'request_quote',
            path: '/new_mvp/retoucherSalary',
          }}}):_vm._e(),(_vm.role === 'pro-retoucher')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_wages,
            icon: 'request_quote',
            path: '/new_mvp/proretoucherSalary',
          }}}):_vm._e(),(_vm.role === 'admin' || _vm.role === 'mini-admin' || _vm.role === 'senior-retoucher' || _vm.role === 'test-admin' || _vm.role === 'tester')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_admin_orders_history,
            icon: 'history',
            path: '/new_mvp/admin_orders_history',
          }}}):_vm._e(),(_vm.role === 'admin' || _vm.role === 'mini-admin' || _vm.role === 'senior-retoucher')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_progress_report,
            icon: 'emoji_events',
            path: '/new_mvp/admin_progress_report',
          }}}):_vm._e(),(_vm.role === 'admin' || _vm.role === 'senior-retoucher' || _vm.role === 'mini-admin')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_admin_reports,
            icon: 'functions',
            path: '/new_mvp/admin-reports',
          }}}):_vm._e(),(_vm.role === 'admin' || _vm.role === 'tester')?_c('sidebar-item',{attrs:{"link":{
            name: 'Аналитика по клиенту',
            icon: 'recent_actors',
            path: '/new_mvp/client-analytics',
          }}}):_vm._e(),(_vm.role === 'retoucher' || _vm.role === 'junior-retoucher')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.location_keys.menu_acquaintance_with_the_account,
            icon: 'smart_display',
            path: '/new_mvp/acquaintance_with_the_account',
          }}}):_vm._e()],2)],2),_c('div',{staticClass:"main-panel"},[_c('div',{staticClass:"tm-padding-small 2"},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }